/*
  uShopAid Bundle Builder guard for bundle product pages.

  The app's picker lists every size and every color of each bundle item, including combos that
  don't exist (e.g. Sateen duvet in California King / Dusty Rose). Picking one leaves that item
  "Sold Out" at $0.00, so the bundle price and "Add to cart - $0.00" follow, and the add fails
  because the app writes no _bundle_selection for it. When a pick lands on such a combo, switch
  the item's other option to the first value the app still marks available (keeping the option
  the shopper just picked). If no value works, the Add to Cart button is marked sold out.
*/
(() => {
  const WRAP = '.ushopaid-bundle-as-product-wrapper';
  const MAX_AUTO_PICKS = 4; // per shopper click, so a bad app state can't loop forever

  let lastPicked = null; // the option row (.select-wrapper) the shopper just changed
  let autoPicks = 0;
  let scheduled = false;

  const isDisabled = (choice) =>
    choice.classList.contains('item-disabled') || !!choice.querySelector(':scope > .line.disabled');

  function check() {
    scheduled = false;
    const wrap = document.querySelector(WRAP);
    if (!wrap) return;

    let blocked = false;
    wrap.querySelectorAll('.product-item').forEach((item) => {
      if (!item.querySelector('.sold-out-text')) return;
      // Try the last option first (usually Color) so the shopper keeps their size
      const rows = [...item.querySelectorAll('.select-wrapper')].filter((row) => row !== lastPicked).reverse();
      if (autoPicks < MAX_AUTO_PICKS) {
        for (const row of rows) {
          const pick = [...row.querySelectorAll('.variant-item, .swatch-box')].find(
            (choice) => !choice.classList.contains('selected') && !isDisabled(choice)
          );
          if (pick) {
            autoPicks += 1;
            (pick.querySelector('.click-content') || pick).click();
            return;
          }
        }
      }
      blocked = true;
    });

    const form = document.querySelector('product-form form[action*="/cart/add"]');
    const submit = form && (form.querySelector('[type="submit"][name="add"]') || form.querySelector('.product-form__submit'));
    if (!submit) return;
    const label = submit.querySelector('span') || submit;
    if (blocked) {
      if (!submit.dataset.bhUshBlocked) submit.dataset.bhUshBlocked = '1';
      if (!submit.disabled) submit.setAttribute('disabled', 'disabled');
      const soldOut = window.variantStrings?.soldOut || 'Sold out';
      if (label.textContent.trim() !== soldOut) label.textContent = soldOut;
    } else if (submit.dataset.bhUshBlocked) {
      delete submit.dataset.bhUshBlocked;
      submit.removeAttribute('disabled');
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!event.isTrusted) return;
      const row = event.target.closest(`${WRAP} .select-wrapper`);
      if (!row) return;
      lastPicked = row;
      autoPicks = 0;
    },
    true
  );

  const observer = new MutationObserver((mutations) => {
    if (scheduled) return;
    const wrap = document.querySelector(WRAP);
    if (!wrap || !mutations.some((m) => wrap.contains(m.target))) return;
    scheduled = true;
    setTimeout(check, 60);
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
})();
